<template>
    <div class="modal fade modern-modal"
         id="ModalWorkflowNovoArtefato"
         tabindex="-1"
         aria-labelledby="ModalWorkflowNovoArtefatoTitulo"
         aria-hidden="true"
         data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content novo-artefato-modal border-0">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 id="ModalWorkflowNovoArtefatoTitulo" class="modal-title">
                            Adicionar artefato
                        </h5>
                        <p class="text-muted mb-0 mt-1">
                            Crie um novo modelo e escolha onde ele entrará neste fluxo.
                        </p>
                    </div>
                    <button type="button"
                            class="btn-close"
                            :disabled="salvando"
                            aria-label="Fechar"
                            @click="fechar"></button>
                </div>

                <form @submit.prevent="salvar">
                    <div class="modal-body pt-4">
                        <div class="mb-4">
                            <label for="novoArtefatoNome" class="form-label fw-semibold">
                                Nome do artefato
                            </label>
                            <input id="novoArtefatoNome"
                                   ref="campoNome"
                                   v-model.trim="form.nmModelo"
                                   class="form-control"
                                   type="text"
                                   maxlength="100"
                                   autocomplete="off"
                                   placeholder="Ex.: Parecer técnico"
                                   :disabled="salvando"
                                   required />
                            <div class="form-text text-end">
                                {{ form.nmModelo.length }}/100
                            </div>
                        </div>

                        <div class="mb-4">
                            <label for="novoArtefatoAnterior" class="form-label fw-semibold">
                                Posição no fluxo
                            </label>
                            <select id="novoArtefatoAnterior"
                                    v-model.number="form.idProcessoWorkflowArtefatoAnterior"
                                    class="form-select"
                                    :disabled="salvando"
                                    required>
                                <option :value="null" disabled>Selecione a posição</option>
                                <option :value="0">Ser o primeiro artefato</option>
                                <option v-for="artefato in artefatosAtivosOrdenados"
                                        :key="artefato.idProcessoWorkflowArtefato"
                                        :value="artefato.idProcessoWorkflowArtefato">
                                    Após {{ artefato.nmModelo }}
                                </option>
                            </select>
                            <div class="form-text">
                                Informe qual artefato ficará imediatamente antes do novo.
                            </div>
                        </div>

                        <fieldset :disabled="salvando">
                            <legend class="form-label fw-semibold mb-2">Ícone</legend>
                            <p class="text-muted small mb-3">
                                Selecione o ícone que representará o artefato nos cards.
                            </p>

                            <div class="icones-grid" role="radiogroup" aria-label="Ícone do artefato">
                                <label v-for="icone in icones"
                                       :key="icone.valor"
                                       class="icone-option"
                                       :class="{ 'is-selected': form.nmIcone === icone.valor }">
                                    <input v-model="form.nmIcone"
                                           class="visually-hidden"
                                           type="radio"
                                           name="novoArtefatoIcone"
                                           :value="icone.valor"
                                           required />
                                    <span class="icone-option__preview" aria-hidden="true">
                                        <IconeSvg :nome="icone.valor" />
                                    </span>
                                    <span class="icone-option__label">{{ icone.rotulo }}</span>
                                </label>
                            </div>
                        </fieldset>
                    </div>

                    <div class="modal-footer border-0 pt-0">
                        <button type="button"
                                class="btn btn-outline-secondary"
                                :disabled="salvando"
                                @click="fechar">
                            Cancelar
                        </button>
                        <button type="submit"
                                class="btn btn-primary d-inline-flex align-items-center gap-2"
                                :disabled="!formValido || salvando">
                            <span v-if="salvando"
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"></span>
                            Adicionar artefato
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import IconeSvg from '@/components/IconeSvg.vue'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'

    export default {
        name: 'ModalWorkflowNovoArtefato',
        components: { IconeSvg },
        props: {
            idProcessoWorkflow: {
                type: Number,
                default: null
            },
            artefatos: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                salvando: false,
                modal: null,
                form: {
                    nmModelo: '',
                    nmIcone: 'account-file-text',
                    idProcessoWorkflowArtefatoAnterior: null
                },
                icones: [
                    { valor: 'account-file-text', rotulo: 'Documento' },
                    { valor: 'account-search', rotulo: 'Pesquisa' },
                    { valor: 'account-injury', rotulo: 'Ocorrência' },
                    { valor: 'account-tag', rotulo: 'Identificação' },
                    { valor: 'account-voice', rotulo: 'Comunicação' },
                    { valor: 'account-star', rotulo: 'Destaque' },
                    { valor: 'account-edit', rotulo: 'Edição' },
                    { valor: 'account-wrench', rotulo: 'Configuração' }
                ]
            }
        },
        computed: {
            artefatosAtivosOrdenados() {
                return (this.artefatos || [])
                    .filter(artefato =>
                        artefato?.flAtivo !== false &&
                        Number(artefato?.idProcessoWorkflowArtefato) > 0
                    )
                    .slice()
                    .sort((a, b) => {
                        const ordemA = a.nrOrdem ?? Number.MAX_SAFE_INTEGER;
                        const ordemB = b.nrOrdem ?? Number.MAX_SAFE_INTEGER;
                        if (ordemA !== ordemB) return ordemA - ordemB;
                        return a.idProcessoWorkflowArtefato - b.idProcessoWorkflowArtefato;
                    });
            },
            formValido() {
                return this.idProcessoWorkflow > 0 &&
                    this.form.nmModelo.trim().length > 0 &&
                    this.form.nmModelo.trim().length <= 100 &&
                    this.form.idProcessoWorkflowArtefatoAnterior !== null &&
                    this.icones.some(icone => icone.valor === this.form.nmIcone);
            }
        },
        methods: {
            obterModal() {
                const elemento = this.$el;
                const bootstrap = window.bootstrap || window.Bootstrap;
                if (!elemento || !bootstrap?.Modal) return null;
                this.modal = bootstrap.Modal.getOrCreateInstance(elemento, {
                    backdrop: 'static',
                    keyboard: false
                });
                return this.modal;
            },
            abrir() {
                this.resetar();
                const modal = this.obterModal();
                if (modal) {
                    modal.show();
                    this.$nextTick(() => this.$refs.campoNome?.focus());
                } else if (window.$?.fn?.modal) {
                    window.$(this.$el).modal({ backdrop: 'static', keyboard: false, show: true });
                }
            },
            fechar() {
                if (this.salvando) return;
                const modal = this.obterModal();
                if (modal) modal.hide();
                else if (window.$?.fn?.modal) window.$(this.$el).modal('hide');
            },
            resetar() {
                this.form = {
                    nmModelo: '',
                    nmIcone: 'account-file-text',
                    idProcessoWorkflowArtefatoAnterior: null
                };
            },
            async salvar() {
                if (!this.formValido || this.salvando) return;
                this.salvando = true;

                try {
                    const resposta = await axios.post(
                        `${urlApi}/ProcessoWorkflow/PostNovoArtefato`,
                        {
                            idProcessoWorkflow: this.idProcessoWorkflow,
                            nmModelo: this.form.nmModelo.trim(),
                            nmIcone: this.form.nmIcone,
                            idProcessoWorkflowArtefatoAnterior:
                                this.form.idProcessoWorkflowArtefatoAnterior
                        }
                    );

                    if (!resposta.data?.success) {
                        throw new Error(resposta.data?.msg || 'Não foi possível adicionar o artefato.');
                    }

                    this.salvando = false;
                    this.fechar();
                    avisoToast('Artefato adicionado ao workflow.', 'success');
                    this.$emit('saved', resposta.data.data);
                } catch (erro) {
                    const mensagem = erro?.response?.data?.msg ||
                        erro?.response?.data?.errors?.[0] ||
                        erro.message ||
                        'Não foi possível adicionar o artefato.';
                    avisoErro(mensagem);
                } finally {
                    this.salvando = false;
                }
            }
        },
        beforeUnmount() {
            if (this.modal?.dispose) this.modal.dispose();
        }
    }
</script>

<style scoped lang="scss">
    .novo-artefato-modal {
        border-radius: 16px;
        box-shadow: 0 24px 70px rgba(15, 23, 42, .22);
    }

    .icones-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 12px;
    }

    .icone-option {
        display: flex;
        min-width: 0;
        min-height: 112px;
        padding: 14px 10px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 9px;
        border: 1px solid var(--bs-border-color, #dee2e6);
        border-radius: 12px;
        background: var(--bs-body-bg, #fff);
        color: var(--bs-secondary-color, #64748b);
        cursor: pointer;
        transition: border-color .16s ease, box-shadow .16s ease, color .16s ease, transform .16s ease;

        &:hover {
            border-color: rgba(37, 99, 235, .48);
            color: #2563eb;
            transform: translateY(-1px);
        }

        &:focus-within {
            outline: 3px solid rgba(37, 99, 235, .18);
            outline-offset: 2px;
        }

        &.is-selected {
            border-color: #2563eb;
            color: #2563eb;
            background: rgba(37, 99, 235, .07);
            box-shadow: 0 0 0 1px #2563eb, 0 8px 20px rgba(37, 99, 235, .12);
        }
    }

    .icone-option__preview {
        display: grid;
        width: 48px;
        height: 48px;
        place-items: center;
        border-radius: 12px;
        background: rgba(148, 163, 184, .12);

        ::v-deep svg {
            display: block;
            fill: currentColor;
        }
    }

    .icone-option__label {
        max-width: 100%;
        overflow: hidden;
        font-size: .78rem;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    @media (max-width: 767.98px) {
        .icones-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
</style>
